skrilla.directive('eventProductFees', function () {
    return {
        templateUrl: 'directives/eventProductFees/eventProductFees.html',
        scope: {
            eventId: "=",
            eventType: "="
        },
        controller: function ($scope, envService, cacheService, searchService, modalService) {
            $scope.tags = cacheService.getObject("productFeeTags")
            $scope.tag = {tag: "", eventType: $scope.eventType};
            $scope.existingTag = "";
            $scope.childSelect = {tag: ""};
            searchService.get("betting/events/productFeeTagTypes").then(function(response){
                var subs = [];
                $scope.tags = response.data;
                $scope.parentToChildren = response.data;
                $scope.tags.forEach(function(tag){
                    subs = subs.concat(tag.second);
                });
                $scope.tags = $scope.tags.filter(function(tag){
                    return !subs.includes(tag.first);
                })
               cacheService.registerObject("productFeeTags", response.data);
                getTag();
            });

            function getTag(){
                searchService.get("betting/events/" + $scope.eventId + "/productFeeTag").then(function(response){
                    if(response.data !== ""){
                        $scope.tag = response.data;
                        $scope.existingTag = $scope.tag.tag;
                        if(!$scope.tags.map(function(tag){return tag.first}).includes($scope.tag.tag)){
                            $scope.parentToChildren.forEach(function(relationship){
                                if(relationship.second.includes($scope.tag.tag)){
                                    $scope.parentSelect = relationship;
                                    $scope.childSelect.tag = $scope.tag.tag;
                                }
                            });
                        }
                        else{
                            $scope.parentSelect = $scope.tags.find(function(tag){return tag.first === $scope.tag.tag});
                        }
                    }
                });
            }

            $scope.save = function(){
                modalService.confirm("Are you sure you'd like to update the product fee tag? This will affecting financial calculations. ", function () {
                    let method = tagExists() ? "put" : "post";
                    searchService[method]("betting/events/" + $scope.eventId + "/productFeeTag", $scope.tag, "Product Fee tag successfully updated!")
                        .then(function(response){
                            getTag();
                        });
                });
            }

            $scope.showButton = function(){
                return $scope.tag.tag !== $scope.existingTag;
            }

            $scope.buttonText = function(){
                return (tagExists() ? "Update" : "Create") + " product fee tag";
            }

            $scope.selected = function(){
                if($scope.parentSelect.second.length > 0){
                    $scope.tag.tag = $scope.childSelect.tag;
                }
                else {
                    $scope.tag.tag = $scope.parentSelect.first;
                }
            }

            function tagExists(){
                return $scope.tag.id !== undefined;
            }
        }
    };
});